import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from './Utils';

class Feedback extends Component {
  constructor() {
    super();
    this.state = {

      data: [{
        dateOfCreation: '',
        patientName: '',
        status: '',
        feedback: '',
      }],
      editedId: "-1",
      pageNum: null,
      paginationValue: 10,
      hidden: false,
      searchTerm: "",
      noMatchingData: false,
      isEdited: false,
      selectedFeedbackStatus: "",
      isLoading: true,
      modalIsOpen: false,
      selectedFeedback: null,
      statusData: [],
      comments: "",
    }
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }
  componentDidMount() {
    var thisController = this;

    thisController.fetchFeedback();
    thisController.fetchFeedbackStatus();

    if (thisController.props.location.state != undefined) {
      thisController.setState({ pageNum: this.props.location.state.pageNum });
    }

  }

  fetchFeedback = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/get-feedback",
      method: 'GET',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var messages = res.result;
          thisController.state.noMatchingData = false;
          thisController.state.isLoading = false;
          thisController.state.data = messages;
          thisController.setState(thisController.state);
        } else {
          // thisController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      }
    });
  }
  fetchFeedbackStatus = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/load-feedback-status",
      method: 'GET',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),

      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.statusData = res.result;
          thisController.state.noMatchingData = false;
          thisController.setState(thisController.state);
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      }
    })
  }

  makeCelledit(row, e) {
    this.markAsBeingEdited(row.id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    this.state.isEdited = true;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  refreshData = () => {
    console.log("Resetting the data");
    this.state.data = [];
    this.state.editedId = "-1";
    this.state.isEdited = false;
    this.state.disabled = false;
    this.state.noMatchingData = false;
    this.state.isLoading = true;
    this.state.searchTerm = "";
    this.setState(this.state);
    this.fetchFeedback();
  }
  updateFeedBack = (row, e) => {
    var updateController = this;
    var feedbackStatus = updateController.state.selectedFeedbackStatus;
    var feedbackData = {
      id: row.id,
      feedbackStatus: feedbackStatus,
    }
    $.ajax({
      url: "/my-jeeva-api/update-feedback",
      method: 'PATCH',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),
        'Content-Type': "application/json",
      },
      data: JSON.stringify(feedbackData),
      success: function (res) {
        if (res.success === true) {
          updateController.state.editedId = "-1";
          updateController.state.disabled = false;
          updateController.state.isEdited = false;
          updateController.closeModal();
          updateController.fetchFeedback();
          updateController.setState(updateController.state);
          console.log("The updated status of feedback is : ", feedbackStatus);
        } else {
          // thisController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      }
    });

  }
  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no feedback present. </p>
    </div>
  );

  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  caseInsensitiveSort = (field) => (rowA, rowB) => {

    if (rowA[field] != null && rowB[field] != null) {
      var a = rowA[field].toLowerCase();
      var b = rowB[field].toLowerCase();
    }
    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  dateSort = (field) => (rowA, rowB) => {

    if (rowA[field] != null && rowB[field] != null) {
      var dateA = rowA[field];
      var dateB = rowB[field];
    }
    for (let i = 0; i < dateA.length; i++) {
      if (dateA[i] > dateB[i]) {
        return 1;
      }
      if (dateA[i] < dateB[i]) {
        return -1;
      }
    }
    return 0;
  };

  formatDate = (dateArray) => {
    if (!dateArray || dateArray.length < 3) return '';
    const [year, month, day] = dateArray;
    return `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;

  }
  // onChangeFeedbackStatus = (row, e) => {
  //   const updatedStatus = e.target.value;
  //   row.feedbackStatus = updatedStatus;
  //   this.setState((prevState) => ({
  //   data: prevState.data.map((r) =>
  //     r.id === row.id ? { ...r, feedbackStatus: updatedStatus } : r
  //   ),
  //   selectedFeedbackStatus : updatedStatus
  // }));
  // }

  openDeletePopUp = (id) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: "Are you sure to delete this? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteFeedback(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  deleteFeedback = (id) => {
    var deleteApiViewController = this;
    $.ajax({
      url: "/my-jeeva-api/delete-feedback/" + id,

      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {

        if (res.success === true) {
          deleteApiViewController.notifyDelete();
          deleteApiViewController.refreshData();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      }
    });
  }
  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all the fields</b>, {
      position: "top-center"
    });

  }
  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Feedback deleted successfully</b>, {
      position: "top-center",
    });
  }

  openModal = (row) => {
    this.setState({ selectedFeedback: row, modalIsOpen: true, selectedFeedbackStatus: row.feedbackStatus });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false, selectedFeedback: null, comments: "" });
  };

  handleSave = (selectedFeedback) => {
    // Implement save logic here
    this.updateFeedBack(selectedFeedback);
    // this.closeModal();
  };

  handleStatusChange = (e) => {
    const updatedStatus = e.target.value;
    this.setState((prevState) => ({
      selectedFeedback: {
        ...prevState.selectedFeedback,
        feedbackStatus: updatedStatus,
      },
      selectedFeedbackStatus: updatedStatus
    }));
  };
  handleCommentChange = (e) => {
    var comments = e.target.value;
    this.state.comments = comments;
    this.setState(this.state);
  };

  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.state.isLoading = true;
    thisController.state.data = [];
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/search-feedback",
      method: "GET",
      data: {
        searchTerm: thisController.state.searchTerm
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.data = [];
            thisController.setState(thisController.state);
            thisController.state.noMatchingData = false;
            thisController.state.isLoading = false;
            thisController.state.data = res.result;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noMatchingData = true;
            thisController.setState(thisController.state);
          }
        }
      },
      error: function (xhr) {

      },
    });

  };

  clearSearchData = () => {
    var thisController = this;
    thisController.setState({ searchTerm: "" }, () => {
      thisController.fetchFeedback();
      thisController.fetchFeedbackStatus();
    });
  }

  render() {
    const { data } = this.state;
    const { modalIsOpen, selectedFeedback } = this.state;
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}> Date of Creation</b>,
        // width: "19vw",
        sortable: true,
        sortFunction: this.dateSort('createdDate'),
        selector: (row) => (
          <div name="createdDate">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                fontSize: "15px",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              id={"createdDate" + row.id}
            >
              {row.createdDate ? this.formatDate(row.createdDate) : ''}
            </div>
          </div>
        ),
      }, {
        name: <b style={{ fontSize: "16px" }}> Patient Name</b>,
        // width: "19vw",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('userName'),
        selector: (row) => (
          <div name="patientName">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                fontSize: "15px",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              id={"patientName" + row.id}
            >
              {row.userName ? row.userName : "Unavailable"}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Status</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('feedbackStatus'),
        // width: "45vw",
        selector: (row) => (
          <div>
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}

              id={"status" + row.id}
              name={"status" + row.id}

            >
              {row.feedbackStatus && typeof row.feedbackStatus === 'string' ? row.feedbackStatus.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : ""}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Feedback</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('feedback'),
        // width: "45vw",
        selector: (row) => (
          <div>
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
                overflowY: "scroll"
              }}
              id={"feedback" + row.id}

            >
              {row.feedback}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Actions</b>,
        width: 100,
        selector: (row) => (
          <div id="action">
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: '-6px'
              }} >
              <img className="img-responsive"
                title="View"
                style={{
                  marginTop: '6px',
                  backgroundColor: '#282a65',
                  borderRadius: '5px',
                  padding: '1px',
                  width: '100%',
                  fontSize: '15px',
                  height: '25px'
                }}
                src={"./assets/images/eye.png"}
                onClick={() => this.openModal(row)}
              />
            </button>
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: '-9px',
                marginLeft: '-6px'
              }}
              title="Delete">
              <img className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                title="Delete"
                style={{
                  marginTop: '6px',
                  backgroundColor: '#282a65',
                  borderRadius: '5px',
                  padding: '1px'
                }}
                onClick={() => (row.id) === '' ?
                  this.refreshData() :
                  this.openDeletePopUp(row.id)}
              />
            </button >
          </div>
        ),
      },
    ];
    return (
      <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        {/* for reactTable */}
        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        {/* Font Awesome Icons */}
        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
        {/* IonIcons */}
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />
        <link rel="stylesheet" href="./assets/css/styles.css" />
        <div className="row" style={{ marginLeft: "15px" }}>
          <div className="col-sm-4" style={{ marginTop: '2px' }} >

          </div>
        </div>
        <div className="row" style={{ marginLeft: '14px' }}>
          <div className="col-sm-5">
            <h6 className="nav-item" style={{ color: '#282a65', marginTop: '15px' }}>
              Feedback</h6>
          </div>
          <div className="col-sm-5" Align="right">
            <input
              type="text"
              style={{
                width: "10vw",
                border: "1px solid #777676",
                borderRadius: "3px",
                padding: "10px",
                height: "0.6vw",
                paddingRight: "2rem",
              }}
              value={this.state.searchTerm}
              onChange={this.handleSearch}
              placeholder="Search ..."
            />
            {this.state.searchTerm && (
              <span
                onClick={() => this.clearSearchData()}
                style={{
                  // position: "absolute",
                  right: "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#777676",
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  lineHeight: 1,
                  userSelect: "none",
                  marginLeft: "-1vw"
                }}
              >
                ×
              </span>
            )}
          </div>
          <div
            // className="col-sm-2 "
            id='addrefresh-btn' style={{
              marginTop: '-18px',
              // marginLeft: "-2vw" 
            }}>
            <div className="d-flex flex-row-reverse pt-2" style={{ marginTop: '-1vh' }}>

              <div className="p-2" style={{ marginBottom: '10px' }}>

                {/* <button className="btn action-button"
                      id="addMsg" title=" Add "
                      onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewVirtualAgentRow}>
                      <img src="assets/images/add_white_24dp.png" />
                    </button> */}
                <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png"></img>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: '15px', marginTop: '-15px' }}>
          <div className="col-lg-12 ">
            {!this.state.noMatchingData &&
              <div className="card">
                {this.state.isLoading && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>Loading ...</p>
                  </div>
                )}
                {!this.state.isLoading && this.state.data.length > 0 && (
                  <DataTable
                    data={this.state.data}
                    columns={columns}
                    defaultPageSize={10}
                    pageSizeOptions={[5, 10, 15]}
                    pagination={this.state.paginationValue}
                    onPageChange={this.onPageChange}
                    page={this.state.pageNum}
                    noDataComponent={<this.CustomNoDataComponent />}
                  />)}
              </div>
            }
            <ToastContainer className="Toast-at-center" />
          </div>
        </div>
        <div className='card'>
          {this.state.noMatchingData &&
            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
              <p>No matching options found ...</p>
            </div>
          }
        </div>
        {modalIsOpen && (
          <div className="modal-feedback" style={{ display: 'block' }}>
            <div className="modal-feedback-content">
              <div className="modal-feedback-header">
                <h2 style={{ color: '#282a65' }}>Feedback Details</h2>
                {/* <span className="close-feedback" onClick={this.closeModal}>
                  &times;
                </span> */}
              </div>
              <div className="modal-feedback-body">
                {selectedFeedback && (
                  <div>
                    <label style={{ color: "black" }}>
                      <strong>Status:</strong>
                      <select
                        value={selectedFeedback.feedbackStatus}
                        onChange={this.handleStatusChange}
                        style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
                      >
                        {this.state.statusData.map((feedbackStatus) => (
                          <option value={feedbackStatus} key={feedbackStatus}>
                            {feedbackStatus.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                          </option>
                        ))}
                      </select>
                    </label>
                    <p>
                      <strong>Feedback:</strong> <br /> {selectedFeedback.feedback}
                    </p>
                    {/* <label style={{ color: "black" }}>
                      <strong>Comment:</strong>
                      <textarea
                        value={this.state.comments}
                        onChange={this.handleCommentChange}
                        style={{ width: '100%', height: '12vh' }}
                      />
                    </label> */}
                  </div>
                )}
              </div>
              <div className="modal-feedback-footer">
                <button onClick={() => { this.handleSave(selectedFeedback) }}>Save</button>
                <button onClick={this.closeModal}>Close</button>

              </div>
            </div>
          </div>
        )}

      </div>
    )
  }
}

export default Feedback;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Feedback.js